// Лента дней матч-центра — чистые функции (без DOM). Как MLS iOS/Android (MatchCenterDayStrip): ±6 дней от СЕГОДНЯ
// (набор не зависит от выбранного дня — тап двигает выделение, а не ленту); день из календаря вне ленты добавляется в
// неё по порядку. Подписи: «Вчера / Сегодня / Завтра» словами, остальные — «Сб 15 авг» в локали языка (без точек и
// запятых, с заглавной). Ключ дня — «YYYY-MM-DD» по местному времени устройства.

export const STRIP_RADIUS = 6;

const pad = (n: number) => String(n).padStart(2, '0');

/** Местная дата устройства → ключ дня. */
export function localDateKey(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

const toUtc = (key: string) => Date.UTC(Number(key.slice(0, 4)), Number(key.slice(5, 7)) - 1, Number(key.slice(8, 10)));
const fromUtc = (ms: number) => { const d = new Date(ms); return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`; };

export const isDayKey = (key: string) => /^\d{4}-\d{2}-\d{2}$/.test(key) && fromUtc(toUtc(key)) === key;
export const addDays = (key: string, n: number) => fromUtc(toUtc(key) + n * 86_400_000);
export const dayDiff = (from: string, to: string) => Math.round((toUtc(to) - toUtc(from)) / 86_400_000);

/** Дни ленты от прошлого к будущему: сегодня ±radius и выбранный, если он вне диапазона. */
export function dayStrip(today: string, selected?: string | null, radius = STRIP_RADIUS): string[] {
  const days = Array.from({ length: radius * 2 + 1 }, (_, i) => addDays(today, i - radius));
  if (!selected || days.includes(selected)) return days;
  return [...days, selected].sort();
}

export interface DayWords { today: string; yesterday: string; tomorrow: string }

/** Подпись дня: соседние — словами, прочие — «день недели число месяц» в локали (григорианский календарь, латинские цифры). */
export function dayLabel(key: string, today: string, words: DayWords, locale: string): string {
  switch (dayDiff(today, key)) {
    case 0: return words.today;
    case -1: return words.yesterday;
    case 1: return words.tomorrow;
    default: {
      const text = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' })
        .format(new Date(toUtc(key)));
      const cleaned = text.replace(/[.,]/g, '').replace(/\s+/g, ' ').trim();
      return cleaned.charAt(0).toLocaleUpperCase(locale) + cleaned.slice(1);
    }
  }
}

/** Сетка месяца календаря: ключи дней, первым — понедельник (null — пустые клетки до 1-го). */
export function monthGrid(month: string): Array<string | null> {
  const first = toUtc(`${month}-01`);
  const lead = (new Date(first).getUTCDay() + 6) % 7;
  const d = new Date(first);
  const length = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
  return [...Array<null>(lead).fill(null), ...Array.from({ length }, (_, i) => `${month}-${pad(i + 1)}`)];
}

/** Соседний месяц «YYYY-MM». */
export function shiftMonth(month: string, n: number): string {
  const d = new Date(Date.UTC(Number(month.slice(0, 4)), Number(month.slice(5, 7)) - 1 + n, 1));
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}`;
}

/** Последний день месяца — граница окна counts/. */
export function monthEnd(month: string): string {
  return addDays(`${shiftMonth(month, 1)}-01`, -1);
}
